import { Link } from "react-router-dom";
import { useGetTermsQuery } from "@/store/api";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

/** Public route — renders the Terms of Service from TERMS.md.
 *  No login required. */
export default function Terms() {
  const { data, isLoading } = useGetTermsQuery();
  return (
    <div className="min-h-screen bg-bg text-fg p-4 lg:p-10">
      <div className="max-w-3xl mx-auto space-y-3">
        <div className="text-xs text-muted">
          <Link to="/login" className="text-accent underline">← Back to sign in</Link>
        </div>
        <Card>
          <CardHeader>
            <CardTitle>Terms of Service & Risk Disclosure</CardTitle>
          </CardHeader>
          <CardContent>
            {isLoading || !data ? (
              <Skeleton className="h-96 w-full" />
            ) : (
              <article className="prose prose-invert max-w-none whitespace-pre-wrap text-sm leading-relaxed">
                {data.markdown}
              </article>
            )}
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
